"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.flatMapObject = exports.flatMap = exports.isNaN = exports.mapCollection = exports.get = exports.sortBy = exports.mapKeys = exports.size = exports.orderBy = exports.isNil = exports.isEmpty = exports.compact = exports.mapValues = exports.keyBy = exports.groupBy = exports.resetQueryParams = exports.limitPriceFromQueryParams = exports.setQueryParam = exports.getQueryParam = exports.invert = exports.invertBN = exports.getConfig = exports.isStableCoin = exports.isNativeBalanceError = exports.isTxRejected = exports.getExplorerUrl = exports.formatDecimals = exports.getTheGraphUrl = exports.supportsTheGraphHistory = exports.devideCurrencyAmounts = exports.safeInteger = exports.parseError = exports.handleFillDelayText = exports.fillDelayText = exports.amountBNV2 = exports.amountUiV2 = exports.amountUi = exports.amountBN = exports.makeElipsisAddress = exports.copy = exports.logger = void 0;
var web3_candies_1 = require("@defi.org/web3-candies");
var moment_1 = __importDefault(require("moment"));
var consts_1 = require("./consts");
var bignumber_js_1 = __importDefault(require("bignumber.js"));
var config_1 = require("./config");
var logger = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    // let debug;
    // if (window) {
    //   const query = new URLSearchParams(window.location.search);
    //   debug = query?.get("twap-debug");
    // }
    // const fromLocalStore = localStorage.getItem("twap-debug");
    // if (process.env.NODE_ENV !== "development") return;
    // if (fromLocalStore) {
    //   console.log(...args);
    // }
};
exports.logger = logger;
var copy = function (text) { return __awaiter(void 0, void 0, void 0, function () {
    var error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!(navigator === null || navigator === void 0 ? void 0 : navigator.clipboard)) {
                    console.warn("Clipboard not supported");
                    return [2 /*return*/, false];
                }
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                return [4 /*yield*/, navigator.clipboard.writeText(text)];
            case 2:
                _a.sent();
                return [2 /*return*/, true];
            case 3:
                error_1 = _a.sent();
                console.warn("Copy failed", error_1);
                return [2 /*return*/, false];
            case 4: return [2 /*return*/];
        }
    });
}); };
exports.copy = copy;
var makeElipsisAddress = function (address, padding) {
    if (!address)
        return "";
    return "".concat(address.substring(0, (padding === null || padding === void 0 ? void 0 : padding.start) || 4), "...").concat(address.substring(address.length - ((padding === null || padding === void 0 ? void 0 : padding.end) || 3)));
};
exports.makeElipsisAddress = makeElipsisAddress;
var amountBN = function (token, amount) { return (0, web3_candies_1.parsebn)(amount).times((0, bignumber_js_1.default)(10).pow((token === null || token === void 0 ? void 0 : token.decimals) || 0)); };
exports.amountBN = amountBN;
var amountUi = function (token, amount) {
    if (!token)
        return "";
    var percision = (0, bignumber_js_1.default)(10).pow((token === null || token === void 0 ? void 0 : token.decimals) || 0);
    return amount.times(percision).idiv(percision).div(percision).toFormat();
};
exports.amountUi = amountUi;
var amountUiV2 = function (decimals, amount) {
    if (!decimals || !amount)
        return "";
    var percision = (0, bignumber_js_1.default)(10).pow(decimals || 0);
    return (0, bignumber_js_1.default)(amount).times(percision).idiv(percision).div(percision).toString();
};
exports.amountUiV2 = amountUiV2;
var amountBNV2 = function (decimals, amount) {
    if (!decimals || !amount)
        return "";
    return (0, web3_candies_1.parsebn)(amount).times((0, bignumber_js_1.default)(10).pow(decimals)).decimalPlaces(0).toString();
};
exports.amountBNV2 = amountBNV2;
var fillDelayText = function (value, translations) {
    if (!value || !translations) {
        return "0";
    }
    var time = moment_1.default.duration(value);
    var days = time.days();
    var hours = time.hours();
    var minutes = time.minutes();
    var seconds = time.seconds();
    var arr = [];
    if (days) {
        arr.push("".concat(days, " ").concat(translations.days, " "));
    }
    if (hours) {
        arr.push("".concat(hours, " ").concat(translations.hours, " "));
    }
    if (minutes) {
        arr.push("".concat(minutes, " ").concat(translations.minutes));
    }
    if (seconds) {
        arr.push("".concat(seconds, " ").concat(translations.seconds));
    }
    return arr.join(" ");
};
exports.fillDelayText = fillDelayText;
var handleFillDelayText = function (text, minutes) {
    return text.replace("{{minutes}}", minutes.toString());
};
exports.handleFillDelayText = handleFillDelayText;
var parseError = function (error) {
    var defaultText = "An error occurred.";
    if (!error || !error.message)
        return defaultText;
    try {
        if (error.message.toLowerCase().indexOf("rejected")) {
            return "Transaction Rejected";
        }
        return defaultText;
    }
    catch (error) {
        return defaultText;
    }
};
exports.parseError = parseError;
var safeInteger = function (value) {
    if ((0, exports.isNaN)(value) || value === "NaN")
        return "0";
    return bignumber_js_1.default.min((0, bignumber_js_1.default)(value || "0").toString(), web3_candies_1.maxUint256)
        .decimalPlaces(0)
        .toString();
};
exports.safeInteger = safeInteger;
var devideCurrencyAmounts = function (_a) {
    var srcAmount = _a.srcAmount, dstAmount = _a.dstAmount, srcToken = _a.srcToken, dstToken = _a.dstToken;
    if (!srcToken || !dstToken || !srcAmount || !dstAmount)
        return;
    var _srcAmount = (0, bignumber_js_1.default)(srcAmount).dividedBy((0, bignumber_js_1.default)(10).pow(srcToken.decimals));
    var _dstAmount = (0, bignumber_js_1.default)(dstAmount).dividedBy((0, bignumber_js_1.default)(10).pow(dstToken.decimals));
    if (!_dstAmount || !_srcAmount || (_srcAmount === null || _srcAmount === void 0 ? void 0 : _srcAmount.isZero()) || (_dstAmount === null || _dstAmount === void 0 ? void 0 : _dstAmount.isZero()))
        return;
    return (0, bignumber_js_1.default)(_dstAmount).div(_srcAmount).toString();
};
exports.devideCurrencyAmounts = devideCurrencyAmounts;
var supportsTheGraphHistory = function (chainId) {
    return chainId ? !!(0, exports.getTheGraphUrl)(chainId) : false;
};
exports.supportsTheGraphHistory = supportsTheGraphHistory;
var getTheGraphUrl = function (chainId) {
    if (!chainId)
        return;
    return config_1.THE_GRAPH_ORDERS_API[chainId];
};
exports.getTheGraphUrl = getTheGraphUrl;
function indexWhereZerosEnd(numberStr) {
    if (!numberStr)
        return 0;
    // Split the number into the integer and decimal parts
    var parts = numberStr.split(".");
    if (parts.length < 2) {
        return -1; // No decimal part
    }
    var decimalPart = parts[1];
    // Match leading zeros in the decimal part
    var match = decimalPart.match(/^(0+)/);
    if (match) {
        // Return the length of the leading zeros (index where zeros end in decimal part)
        return match[1].length;
    }
    else {
        // If there are no leading zeros, return 0
        return 0;
    }
}
var formatDecimals = function (value, decimalPlaces) {
    if (!value)
        return "";
    var index = indexWhereZerosEnd((0, bignumber_js_1.default)(value).toString());
    var decimals = decimalPlaces || 6;
    var res = (0, bignumber_js_1.default)(value).gt(1) && index >= 1 ? 0 : index > 8 ? 0 : index + decimals;
    return (0, bignumber_js_1.default)(value).decimalPlaces(res, bignumber_js_1.default.ROUND_DOWN).toString();
};
exports.formatDecimals = formatDecimals;
var getExplorerUrl = function (chainId) {
    if (!chainId)
        return;
    return consts_1.EXPLORER_URLS[chainId];
};
exports.getExplorerUrl = getExplorerUrl;
var isTxRejected = function (error) {
    var _a, _b, _c, _d;
    if (error === null || error === void 0 ? void 0 : error.message) {
        return ((_b = (_a = error.message) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === null || _b === void 0 ? void 0 : _b.includes("rejected")) || ((_d = (_c = error.message) === null || _c === void 0 ? void 0 : _c.toLowerCase()) === null || _d === void 0 ? void 0 : _d.includes("denied"));
    }
};
exports.isTxRejected = isTxRejected;
var isNativeBalanceError = function (error) {
    var _a;
    try {
        if (error) {
            var message = ((_a = error === null || error === void 0 ? void 0 : error.message) === null || _a === void 0 ? void 0 : _a.toLowerCase()) || (error === null || error === void 0 ? void 0 : error.toLowerCase());
            return (message === null || message === void 0 ? void 0 : message.includes("insufficient")) || (message === null || message === void 0 ? void 0 : message.includes("gas required exceeds allowance"));
        }
    }
    catch (error) { }
};
exports.isNativeBalanceError = isNativeBalanceError;
var isStableCoin = function (token) { return consts_1.STABLE_TOKENS.includes((token === null || token === void 0 ? void 0 : token.symbol.toLowerCase()) || ""); };
exports.isStableCoin = isStableCoin;
var getConfig = function (configs, chainId) {
    return configs.find(function (it) { return it.chainId === chainId; }) || configs[0];
};
exports.getConfig = getConfig;
var invertBN = function (value) {
    if (!value)
        return "";
    return (0, web3_candies_1.bn)(1).multipliedBy(1e18).dividedBy(value).multipliedBy(1e18).decimalPlaces(0).toString();
};
exports.invertBN = invertBN;
var invert = function (value) {
    if (!value)
        return "";
    return (0, bignumber_js_1.default)(1).div(value).toString();
};
exports.invert = invert;
var getQueryParam = function (name) {
    return undefined;
    // if (!window) return;
    // const search = window.location.search;
    // const params = new URLSearchParams(search);
    // const result = params.get(name);
    // if (name === QUERY_PARAMS.LIMIT_PRICE && result === ".") {
    //   return "0.1";
    // }
    // return result;
};
exports.getQueryParam = getQueryParam;
var setQueryParam = function (name, value) {
    // if (!window) return;
    // const search = window.location.search;
    // const params = new URLSearchParams(search);
    // if (!value) {
    //   params.delete(name);
    // } else {
    //   params.set(name, value);
    // }
    // window.history.replaceState({}, "", `${window.location.pathname}?${params}`);
};
exports.setQueryParam = setQueryParam;
var limitPriceFromQueryParams = function () {
    var price = (0, exports.getQueryParam)(consts_1.QUERY_PARAMS.LIMIT_PRICE);
    if (price && (0, bignumber_js_1.default)(price).gt(0)) {
        return (0, exports.formatDecimals)(price);
    }
};
exports.limitPriceFromQueryParams = limitPriceFromQueryParams;
var resetQueryParams = function () {
    (0, exports.setQueryParam)(consts_1.QUERY_PARAMS.INPUT_AMOUNT, undefined);
    (0, exports.setQueryParam)(consts_1.QUERY_PARAMS.LIMIT_PRICE, undefined);
    (0, exports.setQueryParam)(consts_1.QUERY_PARAMS.MAX_DURATION, undefined);
    (0, exports.setQueryParam)(consts_1.QUERY_PARAMS.TRADE_INTERVAL, undefined);
    (0, exports.setQueryParam)(consts_1.QUERY_PARAMS.TRADES_AMOUNT, undefined);
};
exports.resetQueryParams = resetQueryParams;
var groupBy = function (array, key) {
    if (array === void 0) { array = []; }
    return array.reduce(function (result, currentItem) {
        var groupKey = currentItem[key];
        if (!result[groupKey]) {
            result[groupKey] = [];
        }
        result[groupKey].push(currentItem);
        return result;
    }, {});
};
exports.groupBy = groupBy;
var keyBy = function (array, key) {
    return array.reduce(function (result, currentItem) {
        var groupKey = currentItem[key];
        result[groupKey] = currentItem;
        return result;
    }, {});
};
exports.keyBy = keyBy;
var mapValues = function (obj, iteratee) {
    return Object.keys(obj).reduce(function (result, key) {
        result[key] = iteratee(obj[key], key);
        return result;
    }, {});
};
exports.mapValues = mapValues;
var compact = function (array) {
    return array.filter(function (value) { return Boolean(value); });
};
exports.compact = compact;
function isEmpty(value) {
    if (value == null) {
        // Check for null or undefined
        return true;
    }
    if (typeof value === "object") {
        if (Array.isArray(value)) {
            // Check for empty array
            return value.length === 0;
        }
        else if (value instanceof Map || value instanceof Set) {
            // Check for empty Map or Set
            return value.size === 0;
        }
        else {
            // Check for empty object
            return Object.keys(value).length === 0;
        }
    }
    return false;
}
exports.isEmpty = isEmpty;
var isNil = function (value) { return value == null; };
exports.isNil = isNil;
var orderBy = function (array, key, order) {
    if (order === void 0) { order = "asc"; }
    return array.slice().sort(function (a, b) {
        var valueA = key(a);
        var valueB = key(b);
        if (valueA < valueB)
            return order === "asc" ? -1 : 1;
        if (valueA > valueB)
            return order === "asc" ? 1 : -1;
        return 0;
    });
};
exports.orderBy = orderBy;
var size = function (value) {
    if (value == null) {
        return 0;
    }
    if (Array.isArray(value) || typeof value === "string") {
        return value.length;
    }
    if (typeof value === "object") {
        return Object.keys(value).length;
    }
    return 0;
};
exports.size = size;
var mapKeys = function (obj, keyMapper) {
    return Object.keys(obj).reduce(function (result, key) {
        var newKey = keyMapper(obj[key], key);
        result[newKey] = obj[key];
        return result;
    }, {});
};
exports.mapKeys = mapKeys;
var sortBy = function (array, iteratee) {
    return array.slice().sort(function (a, b) {
        var valueA = iteratee(a);
        var valueB = iteratee(b);
        return valueA - valueB;
    });
};
exports.sortBy = sortBy;
var get = function (obj, path) {
    return path.reduce(function (acc, key) { return acc && acc[key]; }, obj);
};
exports.get = get;
var mapCollection = function (collection, iteratee) {
    if (!collection || !iteratee) {
        return [];
    }
    if (Array.isArray(collection)) {
        // Handle case when collection is an array
        return collection.map(function (item, index) { return iteratee(item, index.toString()); });
    }
    else {
        // Handle case when collection is an object
        return Object.entries(collection).map(function (_a) {
            var key = _a[0], item = _a[1];
            return iteratee(item, key);
        });
    }
};
exports.mapCollection = mapCollection;
var isNaN = function (value) {
    return typeof value === "number" && Number.isNaN(value);
};
exports.isNaN = isNaN;
var flatMap = function (collection, iteratee) {
    var result = [];
    if (!collection) {
        return result; // Return empty array if collection is undefined
    }
    if (Array.isArray(collection)) {
        // Handle case when collection is an array
        for (var index = 0; index < collection.length; index++) {
            var mapped = iteratee ? iteratee(collection[index], index) : [collection[index]];
            result.push.apply(result, mapped);
        }
    }
    else {
        // Handle case when collection is an object
        for (var key in collection) {
            if (collection.hasOwnProperty(key)) {
                var mapped = iteratee ? iteratee(collection[key], key) : [collection[key]];
                result.push.apply(result, mapped);
            }
        }
    }
    return result;
};
exports.flatMap = flatMap;
var flatMapObject = function (obj, iteratee) {
    if (!obj) {
        return [];
    }
    return Object.entries(obj).flatMap(function (_a) {
        var key = _a[0], value = _a[1];
        return iteratee ? iteratee(value, key) : [value];
    });
};
exports.flatMapObject = flatMapObject;
